import React from 'react';
import styled from 'styled-components';

const EmptyStateContainer = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: #6b7280;
`;

const EmptyStateText = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  opacity: 0.7;
`;

/**
 * Переиспользуемый компонент для отображения пустого состояния
 * @param {Object} props
 * @param {string} [props.message='Нет данных'] - Текст сообщения
 * @param {React.ReactNode} [props.children] - Дополнительный контент
 */
const EmptyState = ({ message = 'Нет данных', children = null }) => {
  return (
    <EmptyStateContainer>
      <EmptyStateText>{message}</EmptyStateText>
      {children}
    </EmptyStateContainer>
  );
};

export default EmptyState;
